import { render, staticRenderFns } from "./RelationChoosePopup.vue?vue&type=template&id=f6c5d30c&scoped=true&"
import script from "./RelationChoosePopup.vue?vue&type=script&lang=js&"
export * from "./RelationChoosePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c5d30c",
  null
  
)

export default component.exports